var config = {
  restApiUri: 'http://localhost:3001/api',
  activityFeedUri: 'ws://localhost:3002',
  activityFeedReconnectionDelay: 5 * 1000,
  backgroundResourcesMaxDelay: 10000,

  googleClientId: 'xxx',
  amazonResizeUrl: 'https://tocpjptk01.execute-api.eu-central-1.amazonaws.com/dev/resize?key=',
  sentryDSN: 'https://xyz@sentry.heyspace.info/2', // WEB

  isTrackingEnabled: false,
  landingPageUrl: 'https://timecamp.com/planner',
  fcm: {
    senderID: 'xxx',
    androidChannelId: 'heyspace',
    androidChannelName: 'Heyspace',
    vapidKey: 'xxx',
    apiKey: 'xxx',
    authDomain: 'heyspace-dce00.firebaseapp.com',
    databaseURL: 'https://heyspace-dce00.firebaseio.com',
    projectId: 'heyspace-dce00',
    storageBucket: 'heyspace-dce00.appspot.com',
  },
  payment: {
    site: 'test-timecamp-test',
  },
  customerMessagingPlatformApiKey: 'xxx',
};

window.__tc3_config = config;

if (typeof module !== 'undefined') {
  module.exports = config;
}
